/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Locked_ByInputs */

const en_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked By`)
};

const fr_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouille par`)
};

const de_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrt von`)
};

const it_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloccato da`)
};

const ru_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировано пользователем`)
};

const es_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado por`)
};

const zh_cn2_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定`)
};

const ja_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック者`)
};

const hi_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वारा बंद`)
};

const pt_pt2_explorer_info_property_locked_by = /** @type {(inputs: Explorer_Info_Property_Locked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trancado por`)
};

/**
* | output |
* | --- |
* | "Locked By" |
*
* @param {Explorer_Info_Property_Locked_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_locked_by = /** @type {((inputs?: Explorer_Info_Property_Locked_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Locked_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_locked_by(inputs)
	if (locale === "de") return de_explorer_info_property_locked_by(inputs)
	if (locale === "it") return it_explorer_info_property_locked_by(inputs)
	if (locale === "ru") return ru_explorer_info_property_locked_by(inputs)
	if (locale === "es") return es_explorer_info_property_locked_by(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_locked_by(inputs)
	if (locale === "ja") return ja_explorer_info_property_locked_by(inputs)
	if (locale === "hi") return hi_explorer_info_property_locked_by(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_locked_by(inputs)
	return en_explorer_info_property_locked_by(inputs)
});